export enum LessonStatus {
  Finished = 'finished',
  InProgress = 'in_progress',
  NotStarted = 'not_started',
  Failed = 'failed',
  ValidateTo = 'validate_to'
}
